<template>
	<div class="dashboard">
		<el-row :gutter="20">
			<el-col :span="6">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon">
							<i class="el-icon-message"></i>
						</div>
						<div class="stat-info">
							<div class="stat-number">{{ stats.emailConfigs || 0 }}</div>
							<div class="stat-label">邮箱配置</div>
						</div>
					</div>
				</el-card>
			</el-col>
			
			<el-col :span="6">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon">
							<i class="el-icon-user"></i>
						</div>
						<div class="stat-info">
							<div class="stat-number">{{ stats.recipients || 0 }}</div>
							<div class="stat-label">收件人总数</div>
						</div>
					</div>
				</el-card>
			</el-col>
			
			<el-col :span="6">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon">
							<i class="el-icon-s-promotion"></i>
						</div>
						<div class="stat-info">
							<div class="stat-number">{{ stats.totalSent || 0 }}</div>
							<div class="stat-label">已发送邮件</div>
						</div>
					</div>
				</el-card>
			</el-col>
			
			<el-col :span="6">
				<el-card class="stat-card">
					<div class="stat-content">
						<div class="stat-icon">
							<i class="el-icon-success"></i>
						</div>
						<div class="stat-info">
							<div class="stat-number">{{ stats.successRate || '0%' }}</div>
							<div class="stat-label">发送成功率</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		
		<el-row :gutter="20" style="margin-top: 20px;">
			
				<el-card>
					<div slot="header">
						<span>快速操作</span>
					</div>
					<div class="quick-actions">
						<el-button type="primary" @click="$router.push('/email-configs')" icon="el-icon-plus">
							添加邮箱配置
						</el-button>
						<el-button type="success" @click="$router.push('/recipients')" icon="el-icon-user-solid">
							管理收件人
						</el-button>
						<el-button type="warning" @click="$router.push('/send-email')" icon="el-icon-s-promotion">
							发送邮件
						</el-button>
					</div>
				</el-card>
			</el-col>
			
			<el-col :span="12">
				<el-card>
					<div slot="header">
						<span>最近发送记录</span>
					</div>
					<div v-if="recentLogs.length === 0" class="empty-state">
						<i class="el-icon-document"></i>
						<p>暂无发送记录</p>
					</div>
					<div v-else class="recent-logs">
						<div v-for="log in recentLogs" :key="log.id" class="log-item">
							<div class="log-subject">{{ log.subject || '无主题' }}</div>
							<div class="log-info">
								<span>成功: {{ log.successCount }}</span>
								<span>失败: {{ log.failedCount }}</span>
								<span>{{ formatDate(log.createdAt) }}</span>
							</div>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	name: 'Dashboard',
	data() {
		return {
			stats: {},
			recentLogs: []
		}
	},
	mounted() {
		this.loadDashboardData();
	},
	methods: {
		async loadDashboardData() {
			try {
				const userId = this.$store.getters.userId;
				
				// 获取统计数据
				const statsResponse = await this.$http.get('/api/dashboard/stats', {
					params: { userId: userId }
				});
				this.stats = statsResponse.data;
				
				// 获取最近发送记录
				const logsResponse = await this.$http.get('/api/dashboard/recent-logs', {
					params: { 
						userId: userId,
						limit: 5
					}
				});
				this.recentLogs = logsResponse.data.recentLogs || [];
			} catch (error) {
				// 一次轻量重试
				try {
					await new Promise(r => setTimeout(r, 500));
					const userId = this.$store.getters.userId;
					const [statsResponse, logsResponse] = await Promise.all([
						this.$http.get('/api/dashboard/stats', { params: { userId } }),
						this.$http.get('/api/dashboard/recent-logs', { params: { userId, limit: 5 } })
					]);
					this.stats = statsResponse.data;
					this.recentLogs = logsResponse.data.recentLogs || [];
					return;
				} catch (e) {}
				console.error('加载仪表盘数据失败:', error);
				this.$message.error('加载仪表盘数据失败');
			}
		},
		formatDate(date) {
			if (!date) return '';
			return new Date(date).toLocaleDateString();
		}
	}
}
</script>

<style scoped>
.dashboard {
	padding: 20px;
}

.stat-card {
	margin-bottom: 20px;
}

.stat-content {
	display: flex;
	align-items: center;
}

.stat-icon {
	font-size: 48px;
	color: #409EFF;
	margin-right: 20px;
}

.stat-info {
	flex: 1;
}

.stat-number {
	font-size: 24px;
	font-weight: bold;
	color: #303133;
	margin-bottom: 5px;
}

.stat-label {
	color: #909399;
	font-size: 14px;
}

.quick-actions {
	display: flex;
	gap: 10px;
	flex-wrap: wrap;
}

.empty-state {
	text-align: center;
	padding: 40px 0;
	color: #909399;
}

.empty-state i {
	font-size: 48px;
	margin-bottom: 10px;
}

.recent-logs {
	max-height: 300px;
	overflow-y: auto;
}

.log-item {
	padding: 10px 0;
	border-bottom: 1px solid #ebeef5;
}

.log-item:last-child {
	border-bottom: none;
}

.log-subject {
	font-weight: bold;
	margin-bottom: 5px;
}

.log-info {
	display: flex;
	gap: 15px;
	font-size: 12px;
	color: #909399;
}
</style> 